import api from '../lib/api'

export const submitOnboarding = (body) =>
  api.post('/manager/onboarding-v2', body).then(r => r.data)
